/* Palmekongen Erhverv (okt 2026): faner, tællere, reveal, klæbende knap, annoncekilde og formular-fremdrift */
(function () {
  if (window.__pkErhverv) return; window.__pkErhverv = true;
  var stille = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* 1. Reveal + tællere + tidslinje */
  function reveal() {
    var el = [].slice.call(document.querySelectorAll('.pk-e [data-e-ind], .pk-e-tal__kort, [data-e-linje]'));
    if (!('IntersectionObserver' in window) || stille) { el.forEach(function (e) { e.classList.add('er-vist'); }); taelAlle(true); return; }
    var o = new IntersectionObserver(function (en) {
      en.forEach(function (x) {
        if (!x.isIntersecting) return;
        x.target.classList.add('er-vist'); o.unobserve(x.target);
        x.target.querySelectorAll('[data-e-taeller]').forEach(function (t) { tael(t); });
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    el.forEach(function (e) { o.observe(e); });
  }
  function tael(t, straks) {
    if (t.dataset.talt) return; t.dataset.talt = '1';
    var maal = parseFloat(t.dataset.eTaeller) || 0;
    if (straks || stille) { t.textContent = maal; return; }
    var start = null, varighed = 1600;
    t.textContent = '0';
    function trin(ts) {
      if (!start) start = ts;
      var p = Math.min((ts - start) / varighed, 1), e = 1 - Math.pow(1 - p, 3);
      t.textContent = Math.round(maal * e);
      if (p < 1) requestAnimationFrame(trin);
    }
    requestAnimationFrame(trin);
  }
  function taelAlle(straks) { document.querySelectorAll('[data-e-taeller]').forEach(function (t) { tael(t, straks); }); }

  /* 2. Faner – med direkte links (#hotel, #byggeri …) og ?branche= */
  function faner() {
    var rod = document.querySelector('[data-e-faner]'); if (!rod) return;
    var knapper = [].slice.call(rod.querySelectorAll('[role="tab"]'));
    var paneler = [].slice.call(rod.querySelectorAll('[role="tabpanel"]'));
    function vaelg(i, fokus, anim) {
      knapper.forEach(function (k, j) { var on = j === i; k.setAttribute('aria-selected', on); k.tabIndex = on ? 0 : -1; });
      paneler.forEach(function (p, j) {
        p.hidden = j !== i;
        if (j === i && anim) { p.classList.remove('er-skiftet'); void p.offsetWidth; p.classList.add('er-skiftet'); }
      });
      if (fokus) knapper[i].focus();
      var k = knapper[i]; if (k.scrollIntoView && rod.querySelector('.pk-e-br__faner').scrollWidth > rod.clientWidth) {
        var bar = k.parentElement; bar.scrollTo({ left: k.offsetLeft - 16, behavior: stille ? 'auto' : 'smooth' });
      }
    }
    knapper.forEach(function (k, i) {
      k.addEventListener('click', function () { vaelg(i, false, true); if (k.dataset.anker) history.replaceState(null, '', '#' + k.dataset.anker); });
      k.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % knapper.length;
        if (e.key === 'ArrowLeft') n = (i - 1 + knapper.length) % knapper.length;
        if (e.key === 'Home') n = 0; if (e.key === 'End') n = knapper.length - 1;
        if (n !== null) { e.preventDefault(); vaelg(n, true, true); }
      });
    });
    function fraUrl(rul) {
      var h = (location.hash || '').replace('#', '').toLowerCase();
      var q = (new URLSearchParams(location.search).get('branche') || '').toLowerCase();
      var noegle = q || h; if (!noegle) return;
      var i = knapper.findIndex(function (k) { return k.dataset.anker === noegle; });
      if (i < 0) return;
      vaelg(i, false, rul);
      if (rul !== false) { var mål = document.getElementById('brancher'); if (mål) mål.scrollIntoView({ behavior: stille ? 'auto' : 'smooth' }); }
    }
    fraUrl(false);
    if ((location.hash || '').length > 1 && knapper.some(function (k) { return '#' + k.dataset.anker === location.hash.toLowerCase(); })) {
      setTimeout(function () { var m = document.getElementById('brancher'); if (m) m.scrollIntoView(); }, 50);
    }
    window.addEventListener('hashchange', function () { fraUrl(true); });
  }

  /* 3. Knapper der forvælger branche i formularen */
  function forvalg() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-vaelg-branche]'); if (!a) return;
      var v = a.getAttribute('data-vaelg-branche'); if (!v) return;
      var r = [].slice.call(document.querySelectorAll('input[name="contact[Branche]"]')).find(function (x) { return x.value.toLowerCase() === v.toLowerCase(); });
      if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
    });
  }

  /* 4. Annoncekilde: første besøg gemmes (utm, gclid, fbclid, li_fat_id) */
  function kilde() {
    var felt = document.querySelector('[data-e-kilde]');
    var p = new URLSearchParams(location.search), dele = [];
    ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) { if (p.get(k)) dele.push(k.replace('utm_', '') + '=' + p.get(k)); });
    if (p.get('gclid')) dele.push('google-klik'); if (p.get('fbclid')) dele.push('meta-klik'); if (p.get('li_fat_id')) dele.push('linkedin-klik');
    var gemt = null;
    try { gemt = sessionStorage.getItem('pk_e_kilde'); if (!gemt && dele.length) { gemt = dele.join(' | '); sessionStorage.setItem('pk_e_kilde', gemt); } } catch (e) { gemt = dele.join(' | '); }
    if (felt) felt.value = (gemt || (document.referrer ? 'henvisning=' + document.referrer.split('/')[2] : 'direkte')).slice(0, 250);
  }

  /* 5. Formular: fremdrift i procent */
  function fremdrift() {
    var form = document.getElementById('pk-erhverv-form'); if (!form) return;
    var pct = form.querySelector('[data-e-pct]'), bar = form.querySelector('[data-e-bar]');
    var dele = [].slice.call(form.querySelectorAll('[data-e-del]'));
    if (!pct || !dele.length) return;
    function opdater() {
      var ok = dele.filter(function (d) {
        var r = d.querySelectorAll('input[type=radio]'); if (r.length) return [].some.call(r, function (x) { return x.checked; });
        var f = d.querySelector('input, select, textarea'); return f && f.value && f.value.trim() !== '';
      }).length;
      var v = Math.round(ok / dele.length * 100);
      pct.textContent = v + ' % udfyldt'; bar.style.width = v + '%';
    }
    form.addEventListener('input', opdater); form.addEventListener('change', opdater); opdater();
    form.addEventListener('submit', function () { var b = form.querySelector('[type=submit]'); if (b && form.checkValidity()) { b.setAttribute('aria-busy', 'true'); b.querySelector('span').textContent = 'Sender …'; } });
  }

  /* 6. Tak-besked i fokus efter afsendelse */
  function tak() { var t = document.querySelector('[data-e-tak]'); if (t) { var k = document.getElementById('tilbud'); if (k) k.scrollIntoView(); t.focus({ preventScroll: true }); } }

  /* 7. Klæbende knap: vises efter hero, skjules ved formularen */
  function sticky() {
    var s = document.querySelector('[data-e-sticky]'); if (!s || !('IntersectionObserver' in window)) return;
    var hero = document.querySelector('#MainContent > .shopify-section'), form = document.getElementById('tilbud');
    var efterHero = false, vedForm = false;
    function vis() { var on = efterHero && !vedForm; s.classList.toggle('er-vist', on); s.setAttribute('aria-hidden', on ? 'false' : 'true'); var a = s.querySelector('a'); if (a) a.tabIndex = on ? 0 : -1; }
    if (hero) new IntersectionObserver(function (e) { efterHero = !e[0].isIntersecting; vis(); }).observe(hero);
    if (form) new IntersectionObserver(function (e) { vedForm = e[0].isIntersecting; vis(); }, { rootMargin: '0px 0px -20% 0px' }).observe(form);
  }

  function start() { reveal(); faner(); forvalg(); kilde(); fremdrift(); tak(); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
